import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button } from 'src/react/components/buttons';
import EmptyPage from 'src/react/recommendations/components/EmptyIdeaList/EmptyPage';

const ExploreMore = (props) => {
  const { exploreMoreHandler, recommendationsSurveyPath } = props;
  return (
    <EmptyPage>
      <Button
        data-testid="explore_more_empty_recommendation_unlock_handler"
        className="flex-full select-none"
        size="large"
        onClick={exploreMoreHandler}
        href={recommendationsSurveyPath}
        style="secondary"
      >
        Explore More
      </Button>
    </EmptyPage>
  );
};

ExploreMore.propTypes = {
  exploreMoreHandler: PropTypes.func,
  recommendationsSurveyPath: PropTypes.string
};

export default ExploreMore;
